<template>
  <div class="play">
    <div style="height: 64px;background-color: #000;position: absolute;top: 0;width: 100%;" ></div>
    <div class="main">
      <div class="topCon content">
        <div class="subject">
          <div class="subject_left">
            <youKuPlay
              :source="vidSrc"
              :videoSource="videoSourceId"
              :thumb="videoObj.videoImg"
              :mediaInfo="mediaInfo"
              @endPlay="nextVideo"
              @login="login"
              @purchase="purchase"
            >
            </youKuPlay>

            <!-- <img
              class="zanting"
              src="../../public/img/newPages/zanting.png"
              alt=""
            />
            <img
              class="jixu"
              src="../../public/img/newPages/jixu.png"
              alt=""
            /> -->
          </div>
          <div class="subject_right">
            <videoNow
              :info="videoObj"
              @iconClick="collectClick"
              @login="login"
              @purchase="purchase"
            />
            <div
              class="collection"
              v-if="
                !dramasObj.disableDramas || dramasObj.episodeList.length > 1
              "
            >
              剧集
            </div>
            <Dramas
              v-if="
                !dramasObj.disableDramas || dramasObj.episodeList.length > 1
              "
              :info="dramasObj"
              @episodeItem="episodeClick"
            />
          </div>
        </div>

        <PlotIntroduced :info="plptOmtrpdicedObj" />
      </div>
    </div>

    <div class="recommend" v-if="seniorityInfo.list.length > 0">
      <div class="title">热门推荐</div>
      <Seniority :info="seniorityInfo" @movieClick="seniorityClick" />
    </div>

    <div class="advertisement" v-if="bottomBanner">
      <a :href="`${bottomBanner.link}`" target="_blank">
        <img :src="bottomBanner.image" :alt="bottomBanner.title" />
      </a>
    </div>
    <!-- 登陆相关 -->
    <loginToast :status="loginStatus" :isClose="changeStatus"></loginToast>
    <RegisteredToast
      :state="registeredState"
      :isClose="closeRegisterFn"
    ></RegisteredToast>
    <forgetPwd :state="fargetState" :isClose="forgetFn"></forgetPwd>

    <!-- 购买/开通VIP -->
    <el-popover
      class="purchase"
      placement="top"
      width="600"
      v-model="showPurchase"
    >
      <h3 v-if="purchaseType === 'vip'">开通VIP</h3>
      <h3 v-else>购买{{ purchaseVideoInfo.name }}</h3>
      <ul v-if="purchaseType === 'vip'" class="vip-list">
        <li
          :class="vipList.index === index ? 'vip-item active' : 'vip-item'"
          v-for="(item, index) of vipList.list"
          :key="index"
          @click="chooseVipType(index, item.id)"
        >
          <h4 class="type-name">{{ item.typeName }}</h4>
          <p class="time">
            <span class="money">¥{{ item.money }}元</span>
            <span class="months">/{{ item.monthNum }}个月</span>
          </p>
          <p class="recommend" v-if="index === 0">推荐</p>
        </li>
      </ul>
      <p class="pay-type">支付方式</p>
      <div class="qrcode">
        <div class="wechat-qrcode">
          <canvas
            class="code-img"
            ref="wechatQRcode"
            v-if="showQrcode"
            title="点击刷新"
            @click="getQRcode"
          >
          </canvas>
          <img
            class="pay-img"
            slot="reference"
            src="@/assets/images/wechatPay.png"
            alt="微信支付"
            @click="getQRcode"
          />
          <div class="pay-tips">
            <h4>微信支付</h4>
            <p>点击获取微信二维码</p>
          </div>
        </div>
        <div class="alipay">
          <img
            class="pay-img"
            src="@/assets/images/alipay.png"
            alt="支付宝支付"
            @click="jumpToAlipay"
          />
          <div class="pay-tips">
            <h4>支付宝支付</h4>
            <p>点击去支付宝支付</p>
          </div>
        </div>
        <div class="pay-desc">
          <h4 v-if="purchaseType === 'vip' && vipList.list[vipList.index]">
            支付<strong>￥{{ vipList.list[vipList.index].money }}元</strong>
          </h4>
          <h4 v-else>
            支付<strong>￥{{ purchaseVideoInfo.money }}元</strong>
          </h4>
          <p v-if="purchaseType === 'vip'">
            支付后刷新页面，即可享受VIP会员权益
          </p>
          <p v-else>支付后刷新页面，即可观看该影片</p>
        </div>
      </div>
      <div style="text-align: right; margin: 0">
        <el-button type="danger" size="mini" plain @click="purchaseClose"
          >关闭</el-button
        >
      </div>
    </el-popover>
  </div>
</template>

<script>
import bus from "@/utils/eventBus";
import { mapState } from "vuex";
import VideoCom from "@/components/zhangqi/VideoCom.vue";
import youKuPlay from "@/components/youKuPlay/YoukuPlay.vue";
import videoNow from "@/components/gaoyinghao/videoNow.vue";
import Scenes from "@/components/gaoyinghao/scenes.vue";
import PlotIntroduced from "@/components/gaoyinghao/plotIntroduced.vue";
import ImageList from "@/components/gaoyinghao/imageList.vue";
import Seniority from "@/components/gaoyinghao/seniority.vue";
import Dramas from "@/components/gaoyinghao/dramas.vue";
import { getToken, getUser } from "../utils/auth.js";
import { trimValues } from "../utils/trimValues.js";
import loginToast from "@/views/Toast/loginToast.vue";
import RegisteredToast from "@/views/Toast/registeredToast";
import forgetPwd from "@/views/Toast/forgetPwd";
import QRCode from "qrcode";

const ua = navigator.userAgent.toLowerCase();

export default {
  name: "YouKuPlayPage",
  components: {
    youKuPlay,
    VideoCom,
    videoNow,
    Scenes,
    PlotIntroduced,
    ImageList,
    Seniority,
    Dramas,
    loginToast,
    RegisteredToast,
    forgetPwd,
  },
  mounted() {
    this.getData();
    bus.$emit("updateFooter", "首页");
    this.getFooterData();
  },
  beforeDestroy() {
    clearInterval(this.wechatTimer);
    this.times = 0;
  },
  computed: {
    ...mapState({
      loginStatusChange: (state) => state.loginStatus,
    }),
  },
  watch: {
    loginStatusChange(status) {
      if (status) {
        this.getData();
      }
    },
  },
  data() {
    return {
      times: 0,
      bottomBanner: null,
      wechatTimer: null, // 支付定时器
      memberTypeId: null,
      showQrcode: false,
      purchaseVideoInfo: {
        id: null,
        name: "",
        money: null,
      },
      vipList: {
        list: [],
        index: 0,
      },
      vipId: 2,
      purchaseType: "",
      showPurchase: false,
      loginStatus: false,
      registeredState: false,
      fargetState: false,
      params: {
        id: this.$route.query.contentId || 40,
      },
      videoFiles: [],
      mediaInfo: null, //当前视频的一些信息
      vidSrc: null, // 视频资源
      videoObj: {
        // 视频信息
        id: null,
        videoImg: "",
        style: {
          width: "100%",
        },
        title: "",
        titleStyle: {
          display: "inline-block",
        },
        viewCounts: 0,
        isVip: false,
        isVipPrice: false,
        price: 0,
        chargeType: null,
        permission: false,
        codeImg: "",
        buttons: [
          {
            icon: require("../assets/icon/collect.png"),
            activeIcon: require("../assets/icon/collection-fill.png"),
            alt: "收藏",
            target: "shoucang",
            isAction: false,
          },
        ],
      },
      plptOmtrpdicedObj: {
        //底部视频简介
        title: "剧情简介",
        icon: require("../assets/icon/word.png"),
        isShow: true,
        isModuleShow: false,
        name: "",
        grade: 0,
        titleStyle: {
          "font-size": "10px",
          color: "#626873",
        },
        coverStyle: {
          width: "100px",
          height: "125px",
        },
        contentStyle: {
          background: "rgb(43, 51, 63)",
          width: "calc(100% - 100px)",
          "font-size": "14px",
        },
        moduleStyle: {
          color: "blue",
        },
        tages: [],
        list: {},
      },
      /*imageListObj: {
                isShow: false,
                type: 'guess',
                title: '猜你喜欢',
                icon: require('../assets/icon/guess.png'),
                titleBtn: '',
                button: [
                    {
                        name: '换一组',
                        target: 'group',
                        icon: require('../assets/icon/group.png'),
                        iconStyle: {
                            width: '13px',
                            height: '13px',
                            "margin-right": '5px'
                        }
                    }
                ],
                list: []
            },*/
      seniorityInfo: {
        title: "热门推荐",
        titleStyle: {
          padding: "20px 40px",
          "margin-bottom": "0px",
        },
        icon: require("../assets/icon/seniority.png"),
        type: "image",
        list: [],
      },
      dramasObj: {
        episode: 1,
        nowEpisode: 1,
        disableDramas: true,
        episodeList: [],
      },
      fileObj: {
        idArr: [], // 视频文件ID
        durationArr: [], // 视频时长
      },
      pageNum: 0, // 第几页
      totalPages: 0, // 一共有几页
      videoSourceId: "", // 视频的Id
    };
  },
  methods: {
    //获取数据
    getData() {
      var that = this;
      this.$axios({
        url: "/realNet/video/getVideoInfos",
        params: {
          id: this.params.id,
          containVideoFile: true,
          token: getToken(),
        },
        headers: { token: getToken() },
        methods: "get",
      }).then(function (res) {
        var data =
          res.data.result && res.data.result.content
            ? res.data.result.content[0]
            : null;
        if (!data)
          if (data.isRmhdDownload) {
            return that.$router.replace({
              name: "DownloadDetailPage",
              query: {
                contentId: data.id,
              },
            });
          }

        // 设置keywords
        let keywordsMeta = document.getElementsByTagName("meta")["keywords"];
        keywordsMeta.content = `${data.videoName}, 免费在线播放观看, ${data.categoryValue}, 瑞网娱乐`;

        trimValues(data);
        if (data.categoryValue.indexOf("电影") < 0)
          that.$set(that.dramasObj, "disableDramas", false);

        var protagonistArr = [];
        var tagesStyle = {
          "border-radius": "10px",
          "font-size": "10px",
          padding: "3px 10px",
        };

        if (!!data.protagonist) {
          var protagonist = data.protagonist.split("、");
          protagonist.map(function (item) {
            protagonistArr.push({ name: item });
          });
        }

        var fid = sessionStorage.getItem("vidSrcId" + that.params.id);
        that.dramasObj.nowEpisode = fid ? parseInt(fid) : 1;
        //电视剧集数
        that.dramasObj.episode = data.files.length;
        that.dramasObj.episodeList = data.files;
        that.videoObj.title = data.videoName;
        that.videoObj.videoImg = data.verticalImage;
        that.videoObj.viewCounts = data.playAmount;
        that.videoObj.price = data.money;
        that.videoObj.chargeType = data.chargeType;
        that.videoObj.permission = data.permission;
        that.videoObj.permissionAds = data.permissionAds;
        that.videoObj.id = that.params.id;

        //剧情简介
        that.plptOmtrpdicedObj.name =
          that.dramasObj.episode > 1
            ? data.videoName + " 第" + that.dramasObj.nowEpisode + "集"
            : data.videoName;
        that.plptOmtrpdicedObj.grade = data.score;
        that.plptOmtrpdicedObj.cover = data.verticalImage;
        that.plptOmtrpdicedObj.list = {
          导演: [{ name: data.director }],
          主演: protagonistArr,
          //'看点': { isTarges: true },
          简介: [{ name: data.description }],
        };
        that.plptOmtrpdicedObj.tages = [
          { title: data.videoLocalityValue, style: tagesStyle },
          { title: data.videoTypeValue, style: tagesStyle },
          { title: data.languageValue, style: tagesStyle },
          { title: data.year, style: tagesStyle },
        ];

        that.videoFiles = data.files.map(function (item) {
          var vidSrc = [];
          if (data.videoStartAdvertisement) {
            if (data.videoStartAdvertisement.file) {
              vidSrc.push({
                sign: "ads",
                type: "video/mp4",
                src: "/realNet/file/" + data.videoStartAdvertisement.file,
              });
            }
          }
          if (ua.match("edge") || ua.match("rv:11")) {
            if (item.fileMp4) {
              vidSrc.push({
                type: "video/mp4",
                src: item.fileMp4 + "?token=" + getToken(),
              });
            }
            if (item.fileHls) {
              vidSrc.push({
                withCredentials: false,
                type: "application/x-mpegURL",
                src: item.fileHls,
              });
            }
            if (item.videoSource) {
              vidSrc.push({
                videoSourceId: item.videoSource,
              });
            }
          } else {
            if (item.fileHls) {
              vidSrc.push({
                withCredentials: false,
                type: "application/x-mpegURL",
                src: item.fileHls,
              });
            }
            if (item.fileMp4) {
              vidSrc.push({
                type: "video/mp4",
                src: item.fileMp4 + "?token=" + getToken(),
              });
            }
            if (item.videoSource) {
              vidSrc.push({
                videoSourceId: item.videoSource,
              });
            }
          }
          /*if (item.file) {
                        vidSrc.push({
                            withCredentials: false,
                            type: "application/x-mpegURL",
                            src: "/realNet/file/uploads/" + item.file + "/out.m3u8"
                        })
                        vidSrc.push({
                            type: "video/mp4",
                            src: "/realNet/upload/" + item.file + "?token=" + getToken()
                        })
                    }*/
          return vidSrc;
        });
        // 清空之前的数据
        that.fileObj = {
          idArr: [],
          durationArr: [],
          videoSource: [], // 优酷资源列表
        };
        data.files.map((item) => {
          that.fileObj.idArr.push(item.id);
          that.fileObj.durationArr.push(item.duration);
          that.fileObj.videoSource.push(item.videoSource); //优酷资源数据
        });

        that.mediaInfo = {
          name: data.videoName, // 视频名称
          videoInfo: { id: that.params.id }, // 视频ID
          videoFileId: that.fileObj.idArr, // 视频文件ID
          episode: that.dramasObj.nowEpisode, // 第几集
          duration: that.fileObj.durationArr, // 视频总时长
          categoryId: data.categoryId, // 栏目id
          videoType: data.videoType, // 类型
          videoLocality: data.videoLocality, // 地区
          pauseAd: data.pauseAdvertisement || "", // 暂停广告图片
          startAd: data.videoStartAdvertisement || "", // 视频广告
          permission: data.permission, // 观看权限
          permissionAds: data.permissionAds, // 跳过广告权限
          chargeType: data.chargeType, // 是否需要购买
          money: data.money, // 购买金额
          videoSource: that.fileObj.videoSource[that.dramasObj.nowEpisode - 1], //视频数字Id
        };
        that.vidSrc = that.videoFiles[that.dramasObj.nowEpisode - 1];
        that.videoSourceId =
          that.fileObj.videoSource[that.dramasObj.nowEpisode - 1];
        that.getVideoScoure();
        // if (that.vidSrc && !that.vidSrc[0].sign)
        //     sessionStorage.setItem("vidSrcId" + that.params.id, that.dramasObj.nowEpisode)

        //that.getDuessList()

        that.getSeniorityList();
        // 查询历史记录
        that.getHistory("", that.fileObj.idArr[that.dramasObj.nowEpisode - 1]);

        // 添加点击量
        getUser() && that.insertPlayAmount(that.params.id);

        if (document.documentElement.scrollTop)
          document.documentElement.scrollTop = 0;
        if (document.body.scrollTop) document.body.scrollTop = 0;
        if (window.pageYOffset) window.pageYOffset = 0;
      });
    },
    // 获取视频资源
    getVideoScoure() {
      let id = this.videoSourceId;
      // let youkuUrl = 'http://player.youku.com/embed/' + id;
      //  this.$refs.youkuPlayer.src = youkuUrl
      if (id) {
        let youkuUrl = "?client_id=" + "f87946c9efe4a1db" + "&video_id=" + id;
        let video_id = window.localStorage.video_id;
        this.$axios
          .get("https://api.youku.com/videos/show.json" + youkuUrl)
          .then((response) => {
            let playerInfo = response.data;
            var storage = window.localStorage;
            if (video_id) {
              if (video_id == JSON.stringify(playerInfo.id)) {
                return;
              } else {
                storage.setItem("video_id", JSON.stringify(playerInfo.id));
                history.go(0);
              }
            }
          });
      }
    },
    getFooterData(title) {
      let _this = this;
      _this
        .$axios({
          url: "/realNet/pageManager/findOne",
          method: "get",
          headers: {
            token: "123456789",
          },
          params: {
            title: title || "首页",
          },
        })
        .then((res) => {
          let result = res.data.result.dataMap;
          _this.bottomBanner = result.bottomBanner
            ? result.bottomBanner[0]
            : null;
        });
    },
    //获取“猜你喜欢”数据
    /*getDuessList() {
            var that = this

            this.$axios({
                url: "/realNet/video/getVideoInfos",
                params: {
                    categoryId: this.mediaInfo.categoryId,
                    videoType: this.mediaInfo.videoType,
                    videoLocality: this.mediaInfo.videoLocality,
                    pageSize: 4,
                    pageNum: this.pageNum,
                    containVideoFile: true
                },
                headers: { token: "123456789" },
                methods: "get"
            }).then(function(res){
                var data = res.data.result.content
                that.imageListObj.list = data.map(item => {
                    return {
                            id: item.id,
                            img: item.verticalImage,
                            name: item.videoName ? item.videoName : '',
                            intro: item.description ? item.description : '',
                            grade: item.score ? item.score : 8,
                            total: item.files.length + '集全'
                        }
                })
                that.totalPages = res.data.result.totalPages
            })
        },*/
    //获取排行榜数据
    getSeniorityList() {
      var that = this;

      this.$axios({
        url: "/realNet/video/getVideoInfos",
        params: {
          categoryId: this.mediaInfo.categoryId,
          videoType: this.mediaInfo.videoType,
          videoLocality: this.mediaInfo.videoLocality,
          pageSize: 12,
          orderByField: "score",
          orderByType: "DESC",
        },
        headers: { token: "123456789" },
        methods: "get",
      }).then(function (res) {
        var data = res.data.result.content;
        that.seniorityInfo.list = data.map((item, idx) => {
          var icon = "";

          switch (idx) {
            case 0:
              icon = require("../assets/icon/1.png");
              break;
            case 1:
              icon = require("../assets/icon/2.png");
              break;
            case 2:
              icon = require("../assets/icon/3.png");
              break;
            default:
              icon = require("../assets/icon/4.png");
              break;
          }

          return {
            id: item.id,
            icon: icon,
            src: item.horizontalImage,
            name: item.videoName ? item.videoName : "",
          };
        });
      });
    },
    //选择集数回调函数
    episodeClick(option) {
      this.dramasObj.nowEpisode = option.num;
      this.plptOmtrpdicedObj.name =
        this.videoObj.title + " 第" + option.num + "集";
      if (option.num - 1 < this.videoFiles.length) {
        this.mediaInfo = {
          name: this.mediaInfo.name, // 视频名称
          videoInfo: this.mediaInfo.videoInfo, // 视频ID
          videoFileId: this.fileObj.idArr[option.num - 1], // 视频文件ID
          duration: this.fileObj.durationArr[option.num - 1], // 视频时长
          episode: option.num, // 第几集
          categoryId: this.mediaInfo.categoryId, // 栏目id
          videoType: this.mediaInfo.videoType, // 类型
          videoLocality: this.mediaInfo.videoLocality, // 地区
          pauseAd: this.mediaInfo.pauseAd || "", // 暂停广告图片
          startAd: this.mediaInfo.startAd || "", // 视频广告链接
          permission: this.mediaInfo.permission, // 观看权限
          permissionAds: this.mediaInfo.permissionAds, // 跳过广告权限
          chargeType: this.mediaInfo.chargeType, // 是否需要购买
          money: this.mediaInfo.money, // 购买金额
          videoSource: this.fileObj.videoSource[option.num - 1], // 优酷资源列表
        };
        this.videoSourceId = this.fileObj.videoSource[option.num - 1];
        this.getVideoScoure(this.fileObj.videoSource[option.num - 1]);
        this.vidSrc = this.videoFiles[option.num - 1];
        if (this.vidSrc)
          sessionStorage.setItem("vidSrcId" + this.params.id, option.num);
      }
      this.getHistory();
    },
    nextVideo() {
      if (this.mediaInfo.episode < this.dramasObj.episode)
        this.episodeClick({ num: this.mediaInfo.episode + 1 });
    },
    //点击收藏事件
    collectClick(option) {
      if (option.button.target === "shoucang") {
        if (getUser()) {
          this.getHistory(
            "click",
            this.fileObj.idArr[this.dramasObj.nowEpisode - 1]
          );
        } else {
          this.$message({
            message: "你还未登录，请先登录",
            type: "warning",
            duration: 1000,
            onClose: () => {
              this.loginStatus = true;
            },
          });
        }
      }
    },
    getHistory(e, id) {
      if (getUser()) {
        var that = this;
        this.$axios({
          url: "/realNet/history/getHistories",
          method: "GET",
          params: {
            categoryId: that.mediaInfo.categoryId, // 栏目ID
            name: that.mediaInfo.name, // 视频名称
            videoFileId: id || that.mediaInfo.videoFileId, // 视频文件ID
            type: 2, // 收藏历史
          },
          headers: {
            token: getToken(),
          },
        })
          .then((res) => {
            if (res.data.result) {
              if (
                res.data.result.content &&
                !that.favorated(res.data.result.content, id)
              ) {
                if (e) {
                  this.insertHistory();
                  this.videoObj.buttons[0].isAction = true;
                  return this.$message.success("收藏成功");
                }
                this.videoObj.buttons[0].isAction = false;
                return;
              } else {
                if (e) {
                  return this.$message.warning("该视频已收藏");
                }
                this.videoObj.buttons[0].isAction = true;
              }
            } else {
              this.$message.warning("收藏失败，请稍后再试");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    favorated: function (records, id) {
      for (var i = 0; i < records.length; ++i) {
        if (
          records[i].videoInfo.videoName === this.mediaInfo.name &&
          records[i].videoFileId === (id || this.mediaInfo.videoFileId)
        ) {
          return true;
        }
      }
      return false;
    },
    insertHistory() {
      if (typeof this.mediaInfo.videoFileId === "object") {
        this.mediaInfo.videoFileId = this.mediaInfo.videoFileId[0];
        this.mediaInfo.duration = this.mediaInfo.duration[0];
      }
      this.$axios({
        url: "/realNet/history/insert",
        method: "POST",
        data: Object.assign(
          {
            customerId: JSON.parse(getUser()).id, // 客户id
            remainingTime: 0, // 剩余时长
            type: 2, // 收藏历史
          },
          this.mediaInfo
        ),
        headers: {
          token: getToken(),
        },
      }).catch((error) => {
        console.log(error);
      });
    },
    // 播放量
    insertPlayAmount(id) {
      this.$axios({
        url: "/realNet/video/updatePlayAmount",
        method: "GET",
        params: {
          id: id,
        },
      })
        .then((res) => {
          console.log(res);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //“猜你喜欢”点击换一组事件
    /*groupClick(btnInfo) {
            if(btnInfo.target === 'group'){
                if(this.pageNum >= this.totalPages)
                    this.pageNum = 0
                this.getDuessList()
                this.pageNum++
            }
        },
        //“猜你喜欢”电影点击事件
        groupItemClick(info) {
            console.log(info)
        },
        //点击开通VIP事件
        buyVipClick(info) {
            console.log(info)
        },*/
    //排行榜内电影点击事件
    seniorityClick(info) {
      this.params.id = info.id;
      this.$router.replace({
        name: "TVplayPage",
        query: {
          contentId: info.id,
        },
      });
      this.getData();
    },
    login() {
      this.loginStatus = true;
    },
    purchase(e) {
      if (e === "vip") {
        this.purchaseType = "vip";
        this.getVipTypeList();
        // 显示购买界面
        this.showPurchase = true;
      } else {
        this.purchaseVideoInfo = e;
        this.purchaseType = "video";
        // 显示购买界面
        this.showPurchase = true;
      }
    },
    // 获取会员类型列表
    getVipTypeList() {
      this.$axios({
        method: "get",
        url: "/realNet/memberType/getMemberTypes",
        headers: {
          token: getToken(),
        },
      })
        .then((res) => {
          this.vipList.list = res.data.result.content;
          this.memberTypeId = this.vipList.list[0].id;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 获取二维码
    getQRcode() {
      if (!getUser()) {
        this.$message({
          message: "你还未登录，请先登录",
          type: "warning",
          duration: 1000,
          onClose: () => {
            this.loginStatus = true;
          },
        });
        return;
      }
      this.times = 0;
      clearInterval(this.wechatTimer);
      let params = {};
      this.purchaseType === "vip"
        ? (params.memberTypeId = this.memberTypeId)
        : (params.videoInfoId = this.purchaseVideoInfo.id);
      this.$axios({
        method: "GET",
        url: "/realNet/pay/vxPayUrl",
        headers: {
          token: getToken(),
        },
        params: params,
      })
        .then((res) => {
          let codeURl = res.data.result;
          this.showQrcode = true;
          this.$nextTick(() => {
            QRCode.toCanvas(this.$refs.wechatQRcode, codeURl, (error) => {
              console.log(error);
            });
          });
          this.wechatTimer = setInterval(() => {
            this.checkPayStatus(res.data.timestamp);
          }, 3000);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 打开支付宝链接
    jumpToAlipay() {
      if (!getUser()) {
        this.$message({
          message: "你还未登录，请先登录",
          type: "warning",
          duration: 1000,
          onClose: () => {
            this.loginStatus = true;
          },
        });
        return;
      }
      clearInterval(this.wechatTimer);
      this.times = 0;
      let params = {};
      this.purchaseType === "vip"
        ? (params.memberTypeId = this.memberTypeId)
        : (params.videoInfoId = this.purchaseVideoInfo.id);
      let newWindow = window.open(window.location.href);
      this.$axios({
        method: "get",
        url: "/realNet/alipay/pay",
        headers: {
          token: getToken(),
        },
        params: params,
      })
        .then((res) => {
          setTimeout(() => {
            newWindow.document.write(res.data);
          }, 500);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    purchaseClose() {
      this.showPurchase = false;
      this.showQrcode = false;
      clearInterval(this.wechatTimer);
      this.times = 0;
    },
    // 查询支付状态
    checkPayStatus(timestamp) {
      this.times++;
      // 超过3分钟仍未支付
      if (this.times > 60) {
        this.$notify.warning({
          title: "支付超时",
          message: "请重新进行支付",
        });
        this.showCode = false;
        clearInterval(this.wechatTimer);
        return false;
      }
      let params = {
        beginTime: timestamp,
        orderByType: "DESC",
      };
      this.$axios({
        url: "/realNet/order/getOrders",
        headers: {
          token: getToken(),
        },
        params: params,
        method: "GET",
      }).then((res) => {
        for (let i of res.data.result.content) {
          if (i.status === 1) {
            this.$notify({
              title: "支付成功",
              message: "即将跳转至订单管理页面",
              type: "success",
              duration: 3000,
              onClose: () => {
                this.$router.push({ name: "Mine", query: { tab: "order" } });
              },
            });
          } else if (i.status === 2) {
            this.$notify({
              title: "支付失败",
              message: "即将跳转至订单管理页面",
              type: "warning",
              duration: 3000,
              onClose: () => {
                this.$router.push({ name: "Mine", query: { tab: "order" } });
              },
            });
          }
        }
      });
    },
    chooseVipType(index, id) {
      this.vipList.index = index;
      this.memberTypeId = id;
    },
    changeStatus(val) {
      this.loginStatus = false;
      if (val == 1) {
        this.registeredState = true;
      } else if (val == 2) {
        this.fargetState = true;
      }
    },
    closeRegisterFn(val) {
      this.registeredState = false;
      if (val) {
        this.loginStatus = true;
      }
    },
    forgetFn() {
      this.fargetState = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.youku_play_page {
  width: 100%;
  background: rgb(43, 51, 63);
  .advertisement {
    margin-top: 28px;
    width: 100%;
    a > img {
      width: 100%;
      height: auto;
    }
  }
}
.topBack {
  width: 90%;
  margin: 0 auto;
}
.video_l {
  width: calc(100% - 350px);
  height: 576px;
  overflow: hidden;
  float: left;
  position: relative;
}
.video_r {
  width: 350px;
  height: 576px;
  overflow: auto;
  float: left;
  background: #10131a;
  &::-webkit-scrollbar {
    display: none;
  }
}
.video_b {
  width: 100%;
  float: left;
}
.content {
  width: 100%;
  margin: auto;
  overflow: hidden;
}
.imageList {
  float: left;
  margin-bottom: 20px;
}
.imageList {
  width: 100%;
}
.seniority {
  width: calc(100% - 20px);
  margin-left: 10px;
}
.bottomCon {
  margin-bottom: 20px;
}
.log {
  position: absolute;
  top: 10px;
  right: 10px;
}
.purchase {
  position: absolute;
  top: 200px;
  left: 30%;
  .pay-type {
    margin-top: 10px;
  }
  .vip-list {
    display: flex;
    margin: 30px 0px 10px;
    .vip-item {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      height: 80px;
      width: calc((100% - 10px) / 4);
      padding: 6px 10px;
      margin-right: 10px;
      border: 1.8px solid #e3e3e3;
      cursor: pointer;
      .time {
        display: flex;
        align-items: center;
        font-weight: 500;
        .money {
          font-size: 18px;
          color: #ff3600;
        }
      }
      .recommend {
        position: absolute;
        top: 50px;
        left: 15px;
        z-index: 0;
        color: #fff;
        &::after {
          content: "";
          position: absolute;
          top: -3px;
          right: -8px;
          background: url("../assets/images/mine/recomond.png") no-repeat;
          height: 28px;
          width: 43px;
          z-index: -1;
        }
      }
    }
    .vip-item.active {
      border: 1.8px solid #ff3600;
    }
  }
  .qrcode {
    display: flex;
    margin: 10px 0px 18px;
    padding: 12px;
    border: 1px solid #e3e3e3;
    .wechat-qrcode,
    .alipay {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 20px;
      .code-img {
        position: absolute;
        height: 112px !important;
        width: 112px !important;
        cursor: pointer;
      }
      .pay-img {
        width: 112px;
        height: 112px;
        border: 1px solid #e3e3e3;
        cursor: pointer;
      }
      .pay-tips {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 8px;
      }
    }
    .pay-desc {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      strong {
        font-size: 18px;
        color: #ff3600;
      }
    }
  }
}
</style>
